import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { startOfWeek, endOfWeek, format, set } from 'date-fns';

// SERVICIOS
import { getDashboardByEvent, getDashboardByDriver } from '../../../services/dashboard/getDatosDashboard';

// ICONOS
import SearchIcon from '@mui/icons-material/Search';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import ModalEventos from './modales/ModalEventos';
import ModalDrivers from './modales/ModalDrivers';

const EventsDashboard = () => {

    const [eventsByType, setEventsByType] = React.useState([]);
    const [eventsByDriver, setEventsByDriver] = React.useState([]);

    useEffect(() => {

        const getData = async () => {

            const { start, end } = getCurrentWeekRange();

            const typeEvents = await getDashboardByEvent(start, end);
            const driverEvents = await getDashboardByDriver(start, end);

            setEventsByType(typeEvents);
            setEventsByDriver(driverEvents);

        }

        getData();

    }, []);

    const getCurrentWeekRange = () => {
        const today = new Date();
        const monday = startOfWeek(today, { weekStartsOn: 1 }); // lunes
        const sunday = endOfWeek(today, { weekStartsOn: 1 });   // domingo

        return {
            start: format(monday, 'yyyy-MM-dd'),
            end: format(sunday, 'yyyy-MM-dd'),
        };
    };

    const eventColumns = [

        { 
            field: 'event_type', 
            headerName: 'Event',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_eventos', 
            headerName: 'Total Events',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'promedio_tiempo_atencion', 
            headerName: 'Response Time',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
    ];

    const driverColumns = [

        { 
            field: 'driver', 
            headerName: 'Driver',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_asset_stops_moving', 
            headerName: 'Stop Moving',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_out_of_route', 
            headerName: 'Out of Route',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_panic_button', 
            headerName: 'Panic Button',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_eventos', 
            headerName: 'Total Events',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
    ];

    const [selectedEvent, setSelectedEvent] = useState(null)

    const handleSelectEvent = ( event ) => {

        setSelectedEvent(event.row.event_type);

        setShowModal({ ...showModal, event: true });

    }

    const [selectedDriver, setSelectedDriver] = useState(null)

    const handleSelectDriver = ( event ) => {

        setSelectedDriver(event.row.driver);

        setShowModal({ ...showModal, driver: true });

    }

    const [showModal, setShowModal] = useState({
        event: false,
        driver: false
    });

    const [dateRange, setDateRange] = useState({
        start: null,
        end: null
    });

    const handleStartDate = ( event ) => {

        setDateRange({...dateRange, start: event.target.value});

    }

    const handleEndDate = ( event ) => {

        setDateRange({...dateRange, end: event.target.value});

    }

    const fetchEvents = async () => {

        if(dateRange.start && dateRange.end){

            // Mostrar mensaje de carga
            Swal.fire({
                title: 'Buscando información...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const typeEvents = await getDashboardByEvent(dateRange.start, dateRange.end);
            const driverEvents = await getDashboardByDriver(dateRange.start, dateRange.end);

            setEventsByType(typeEvents);
            setEventsByDriver(driverEvents);

            Swal.close();

        } else {

            Swal.fire({
                icon: 'error',
                title: 'Fecha de inicio y fin requeridas',
            });

        }

    }

    // =========================================

    return (

        <Grid container spacing={2}>

            <Grid size={12}>

                <input 
                    type="date" 
                    placeholder="start" 
                    style={{ marginRight: '1rem' }}
                    onChange={handleStartDate}
                />

                <input 
                    type="date" 
                    placeholder="end" 
                    onChange={handleEndDate}
                />

                <Button
                    onClick={fetchEvents}
                >
                    <SearchIcon />
                </Button>

            </Grid>

            <Grid size={6}>

                <Typography
                    textAlign={'center'}
                    variant='subtitle1'
                    fontWeight={700}
                >
                    Summary of Events
                </Typography>

            </Grid>

            <Grid size={6}>

                <Typography
                    textAlign={'center'}
                    variant='subtitle1'
                    fontWeight={700}
                >
                    Summary of Drivers
                </Typography>

            </Grid>

            <Grid size={6}>

                <MiTabla
                    columns={eventColumns}
                    data={eventsByType}
                    onRowClick={handleSelectEvent}
                />

            </Grid>

            <Grid size={6}>

                <MiTabla
                    columns={driverColumns}
                    data={eventsByDriver}
                    onRowClick={handleSelectDriver}
                />

            </Grid>

            {/* MODAL EVENTOS */}

            <ModalEventos
                open={showModal.event}
                onClose={() => setShowModal({ ...showModal, event: false })}
                event={selectedEvent}
            />

            {/* MODAL DRIVERS */}

            <ModalDrivers
                open={showModal.driver}
                onClose={() => setShowModal({ ...showModal, driver: false })}
                driver={selectedDriver}
            />

        </Grid>

    )

}

export default EventsDashboard